const defaultState = {
  enviosReferencia: [],
  loading: false,
  error: null,
  ticketLoading: false,
  ticketError: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_ENVIOS_REFERENCIA_START':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'GET_ENVIOS_REFERENCIA_SUCCESS':
      return {
        ...state,
        enviosReferencia: action.payload,
        loading: false,
        error: null,
      };

    case 'GET_ENVIOS_REFERENCIA_ERROR':
      console.log('❌ REDUCER: Error en envíos:', action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'ENVIAR_REFERENCIA_START':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'ENVIAR_REFERENCIA_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null,
      };

    case 'ENVIAR_REFERENCIA_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Ticket de envío de referencia
    case 'GENERATE_TICKET_ENVIO_REFERENCIA_START':
      return {
        ...state,
        ticketLoading: true,
        ticketError: null,
      };
    case 'GENERATE_TICKET_ENVIO_REFERENCIA_SUCCESS':
      return {
        ...state,
        ticketLoading: false,
        ticketError: null,
      };
    case 'GENERATE_TICKET_ENVIO_REFERENCIA_ERROR':
      return {
        ...state,
        ticketLoading: false,
        ticketError: action.payload,
      };

    default:
      return state;
  }
};
